import script from "./tutorOnboardingSeventhPage.vue?vue&type=script&setup=true&lang=js"
export * from "./tutorOnboardingSeventhPage.vue?vue&type=script&setup=true&lang=js"

import "./tutorOnboardingSeventhPage.vue?vue&type=style&index=0&id=ca610480&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca610480"]])

export default __exports__